module.exports = __webpack_public_path__ + "static/media/inventory-scanner.4f666b16.svg";